import React from 'react';

import { generateClient } from 'aws-amplify/api';

import { ChatMessageItem } from '../../graphql/API';
import { onMessagingBtwVenueAndUser } from '../../graphql/subscriptions';
import { GqlError, getError, getErrorFromResult, processGqlResult } from '../../utils/gql-utils';

const client = generateClient();

export const useOnMessagingBtwVenueAndUserEventListener = (toUserId: string) => {
  const [message, setMessage] = React.useState<Nullable<ChatMessageItem>>(null);
  const [error, setErorr] = React.useState<GqlError>();

  React.useEffect(() => {
    if (toUserId) {
      const createSub = client.graphql({
        query: onMessagingBtwVenueAndUser,
        variables: { userType: 'venue/user', toUserId },
      }).subscribe({
        next: ({ data }: { data: { onMessagingBtwVenueAndUser: ChatMessageItem } }) => {
          const _message = processGqlResult<ChatMessageItem>('onMessagingBtwVenueAndUser', { data });
          setMessage(_message);
          const errorFromResponse = getErrorFromResult({ data });

          if (errorFromResponse) {
            throw errorFromResponse;
          }
        },
        error: (ex) => {
          const raisedError = getError(ex);
          console.error(raisedError);
          setErorr(raisedError);
        },
      });

      return () => {
        createSub.unsubscribe();
      };
    }
  }, [setMessage, toUserId]);

  return {
    message,
    error,
  };
};
